import Contact from "../components/Contact";
function ContactPage() {
  return <Contact />;
}
export default ContactPage;